import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { DownloadFile, Icon, InputWithIcon } from '@livable/saas-react-components';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, ToggleButtonGroup, ToggleButton, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useStore } from 'src/stores';
import { PROPERTY_STATUS_ENUM } from 'src/constants/property';
import { generateAddressString } from 'src/utils/address';
import useStyles from './styles';
export const TenantAddendumsTab = observer(() => {
  const classes = useStyles();
  const store = useStore();
  const navigate = useNavigate();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState('all'),
    _useState2 = _slicedToArray(_useState, 2),
    properties = _useState2[0],
    setProperties = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchKey = _useState4[0],
    setSearchKey = _useState4[1];
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    residentsAddendumsData = _useState6[0],
    setResidentsAddendumsData = _useState6[1];
  const handlePropertiesChange = (e, value) => {
    if (value) setProperties(value);
  };
  const handleSearchKeyChange = e => {
    setSearchKey(e.target.value);
  };
  const fetchPropertiesList = async () => {
    const propertyAddendumsList = [];
    const propertiesData = await store.company.getResidentsAddendumsAsync.run();
    if (propertiesData.isSuccessful && propertiesData.response.length) {
      propertyAddendumsList.push(...propertiesData.response);
      setResidentsAddendumsData(propertyAddendumsList);
    }
  };
  useEffect(() => {
    try {
      fetchPropertiesList();
    } catch (e) {
      console.log('useEffect Error', e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.pageWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.filtersWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.searchWrapper
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "charges-search",
    label: t('general.search'),
    variant: "outlined",
    onChange: handleSearchKeyChange,
    fullWidth: true
  }))), /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: properties,
    onChange: handlePropertiesChange,
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "all"
  }, t('file_cabinet.show_all_properties')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "active"
  }, t('file_cabinet.active_properties')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "inactive"
  }, t('file_cabinet.inactive_properties')))), /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table, {
    "aria-label": "resident addendums table",
    type: "fullWidth"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    className: classes.mainCell
  }, t('file_cabinet.property_address')), /*#__PURE__*/React.createElement(TableCell, null, t('file_cabinet.addendums')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('file_cabinet.download')))), /*#__PURE__*/React.createElement(TableBody, null, store.company.getResidentsAddendumsAsync.inProgress ? /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, t('file_cabinet.loading')), /*#__PURE__*/React.createElement(TableCell, null, t('file_cabinet.loading')), /*#__PURE__*/React.createElement(TableCell, null, t('file_cabinet.loading'))) : residentsAddendumsData.filter(i => {
    if (properties === 'active') {
      return i.propertyStatus === PROPERTY_STATUS_ENUM.Active;
    } else if (properties === 'inactive') {
      return i.propertyStatus === PROPERTY_STATUS_ENUM.Inactive;
    } else {
      return true;
    }
  }).filter(i => {
    const searchPhrase = new RegExp(searchKey, 'gi');
    return searchKey.length > 0 ? " ".concat(generateAddressString(i.address)).search(searchPhrase) > 0 : true;
  }).map(propertyAddendums => {
    var _store$fileCabinet$ge;
    return /*#__PURE__*/React.createElement(TableRow, {
      key: propertyAddendums.propertyId,
      className: classes.tableRow,
      onClick: () => navigate("/addendums_files?id=".concat(propertyAddendums.propertyId), {
        state: {
          address: generateAddressString(propertyAddendums.address)
        }
      })
    }, /*#__PURE__*/React.createElement(TableCell, null, propertyAddendums.propertyStatus === PROPERTY_STATUS_ENUM.Active && /*#__PURE__*/React.createElement(Icon, {
      color: "success",
      type: "building"
    }), propertyAddendums.propertyStatus === PROPERTY_STATUS_ENUM.Inactive && /*#__PURE__*/React.createElement(Icon, {
      type: "building-minus",
      color: "grey"
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "h5",
      className: classes.title
    }, generateAddressString(propertyAddendums.address))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Icon, {
      type: "file-text"
    }), /*#__PURE__*/React.createElement("span", {
      className: classes.amount
    }, propertyAddendums.fileCount)), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, /*#__PURE__*/React.createElement(DownloadFile, {
      disabled: propertyAddendums.fileCount <= 0 || ((_store$fileCabinet$ge = store.fileCabinet.getFilesArchiveAsync) === null || _store$fileCabinet$ge === void 0 ? void 0 : _store$fileCabinet$ge.inProgress),
      usePreSignedDownload: store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled,
      fileId: propertyAddendums.fileIds,
      multiple: true,
      store: store,
      text: "file_cabinet.download_all_files"
    })));
  })))));
});